import { render, staticRenderFns } from "./AncillariesAutomatedOffer.vue?vue&type=template&id=f15bd63c&scoped=true"
import script from "./AncillariesAutomatedOffer.vue?vue&type=script&lang=js"
export * from "./AncillariesAutomatedOffer.vue?vue&type=script&lang=js"
import style0 from "./AncillariesAutomatedOffer.vue?vue&type=style&index=0&id=f15bd63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15bd63c",
  null
  
)

export default component.exports